import React, { Component } from 'react';
import PropTypes from 'prop-types'
import getLocaleMessages from '../../utils/localesMessages';

const {
	header,
	note,
	loginButton,
	continueButton
} = getLocaleMessages('buttons/loginModal');

const {
	close
} = getLocaleMessages('buttons/errors');


export class LoginModal extends Component {
	static propTypes = {
		buttonFactory: PropTypes.object,
		closeModal: PropTypes.func,
		handleLogin: PropTypes.func
	}

	render() {
		return (
			<div
				className={`vx_modal-glimpse vx_modalPrepToOpen login_modal ${this.props.buttonFactory.showLoginModal ? 'vx_modalIsOpen' : ''}`}
				id="login-modal"
				role="dialog"
				aria-describedby="login-modal-header"
				tabIndex="0"
				aria-label="Modal Dialog"
			>
				<div className="vx_modal-content">
					<button
						className="vx_modal-dismiss_x-trigger"
						data-modal-id="_demoVxModal-glimpse"
						onClick={this.props.closeModal}
						id="closeLoginModal"
					>
						<span className="vx_a11yText">{close}</span>
					</button>

					<header className="vx_modal-header" id="login-modal-header">
						<p>{header}</p>
					</header>

					<div className="vx_modal-body">
						<p>{note}</p>
						<button
							className="vx_btn vx_btn-primary"
							type="submit"
							onClick={this.props.handleLogin}
							id="loginBtn"
						>
							{loginButton}
						</button>
						<button
							className="vx_btn vx_btn-secondary"
							type="submit"
							onClick={this.props.closeModal}
						>
							{continueButton}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default LoginModal;



// WEBPACK FOOTER //
// ./buttons/components/modals/LoginModal.js